import { Component, Input } from '@angular/core';
import { LogSignature, LogUpdate } from '../form-history-services/form-history.service';

@Component({
  selector: 'form-history-signatures',
  templateUrl: './form-history-signatures.component.html',
  styleUrls: ['./form-history-signatures.component.scss'],

})
export class FormHistorySignaturesComponent {
  @Input() update?: LogUpdate;

  /**
   * Removes system-generated amendment activity from the amendment signature cards.
   * @returns Amendment signatures that should be displayed for the selected history entry.
   */
  get visibleSignatures(): LogSignature[] {
    return this.update?.signatures?.filter(signature => {
      const name = signature.name?.trim() ?? '';
      return name !== 'Update/FinishAmendment update' && !name.includes('Amendment Created');
    }) ?? [];
  }
}
